import React from "react";

const CustomIcon = ({width, height, src, alt, className}) => {
    return (
        <img className={className} src={src} alt={alt} width={width} height={height}/>
    );
};

export default CustomIcon;
